/*
@author: Nikhil 

jvtrunk8
============
@desc: Used to show an ellipsis 

 */
angular.module('jv.Common.Directives.trunk8', [])
.directive('jvTrunk8',['$timeout',function($timeout){
        var directiveDefinitionObject = {
            scope:{
                offset:'='
            },
            link: function($scope, iElm, iAttrs, ngModel) {
                var childContainer = $(iElm),parentContainer = childContainer.parent(), childContainerWidth, parentContainerWidth;
                $timeout(function(){
                    parentContainer.css('white-space','nowrap');
                    childContainerWidth = parseInt(childContainer.css('width').split('px')[0],10);
                    parentContainerWidth = parseInt(parentContainer.css('width').split('px')[0] ,10);
                    var title = childContainer.text();
                    childContainer.attr('title',title);
                    if( childContainerWidth >= parentContainerWidth ){
                        if($scope.offset){
                            parentContainer.css('width',$scope.offset+'%');
                        }else{
                            parentContainer.css('width','100%');
                        }
                        parentContainer.addClass('ellipsis');
                    }
                },50);
            }
        };
        return directiveDefinitionObject;
}]);
